/* global axios */
import ApiClient from './ApiClient';

class FunnelReportsAPI extends ApiClient {
  constructor() {
    super('reports/funnel', { accountScoped: true, apiVersion: 'v2' });
  }

  show(params = {}) {
    return axios.get(this.url, { params });
  }

  export(params = {}) {
    return axios.get(`${this.url}/export`, { params, responseType: 'blob' });
  }

  drillPreAttendance(params = {}) {
    return axios.get(`${this.url}/pre_attendance_drill`, { params });
  }
}

export default new FunnelReportsAPI();
